import { MbCartEffects } from './mb-cart.effect'

export const effects: any[] = [
  MbCartEffects
]

export * from './mb-cart.effect'
